export const EXPENSE_OCR_PREFILL_FIELDS = ["purchaseDate", "totalValue", "itemOrService"];

function normalizedText(value) {
  if (typeof value !== "string") return null;
  const text = value.replace(/\s+/g, " ").trim();
  return text || null;
}

function isTechnicalDiscountName(name) {
  const technicalName = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
  return /^(OPUSTY?|RABATY?)(\s|$)/.test(technicalName);
}

function readableUppercaseWord(word) {
  if (!word || word !== word.toLocaleUpperCase("pl-PL") || word === word.toLocaleLowerCase("pl-PL")) return word;
  if (/\d/.test(word) || word.length <= 2) return word;
  const lower = word.toLocaleLowerCase("pl-PL");
  return lower.replace(/[a-ząćęłńóśźż]/i, (letter) => letter.toLocaleUpperCase("pl-PL"));
}

export function cleanOcrItemName(value) {
  const normalized = normalizedText(value);
  if (!normalized) return null;
  let cleaned = normalized.replace(/^\d{1,4}I?SZTUKA(?:\s+|$)/i, "").trim();
  cleaned = cleaned.replace(/\s+#\s*\d+\b/g, "").replace(/\s+/g, " ").trim();
  const setDescription = /^.+?\s+×\s*(\d+)\s+([^\s/]+)\s+\/zestaw\s+\d+\s+szt\.?\s+(.+)$/i.exec(cleaned);
  if (setDescription) cleaned = `Zestaw ${setDescription[1]} ${setDescription[3]} ${setDescription[2]}`;
  if (!cleaned) return null;
  return cleaned.split(" ").map(readableUppercaseWord).join(" ");
}

function meaningfulItemNames(items) {
  if (!Array.isArray(items)) return [];
  return items
    .map((item) => cleanOcrItemName(item?.name))
    .filter((name) => name && !isTechnicalDiscountName(name));
}

function uniqueNames(names) {
  const seen = new Set();
  return names.filter((name) => {
    const key = name.toLocaleUpperCase("pl-PL");
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

export function buildOcrItemDescription(items) {
  const names = uniqueNames(meaningfulItemNames(items));
  return names.length > 0 ? names.join(", ") : null;
}

export function buildExpenseItemDescription(ocrData) {
  if (!ocrData || typeof ocrData !== "object") return null;
  const names = meaningfulItemNames(ocrData.items);
  if (names.length === 0) return null;
  if (names.length >= 4) {
    const merchant = normalizedText(ocrData.merchant?.name);
    return merchant ? `Zakupy – ${merchant}` : "Zakupy – kilka pozycji";
  }
  return uniqueNames(names).join(", ") || null;
}

export function applyExpenseOcrPrefill(form, ocrData, dirtyFields = {}) {
  if (!ocrData || typeof ocrData !== "object") return form;
  const next = { ...form };

  if (!dirtyFields.purchaseDate && typeof ocrData.issue_date === "string"
    && /^\d{4}-\d{2}-\d{2}$/.test(ocrData.issue_date)) {
    next.purchaseDate = ocrData.issue_date;
  }

  const gross = ocrData.totals?.gross;
  if (!dirtyFields.totalValue && typeof gross === "number" && Number.isFinite(gross) && gross >= 0) {
    next.totalValue = String(gross);
  }

  const description = buildExpenseItemDescription(ocrData);
  if (!dirtyFields.itemOrService && description) next.itemOrService = description;

  if (ocrData.document_type === "invoice") next.confirmationType = "Faktura / PDF";
  if (ocrData.document_type === "receipt") next.confirmationType = "Paragon";

  return next;
}
